module.exports = __webpack_public_path__ + "img/weixinpay.e8a382e4.svg";